import apiFetch from '../apiFetch'

export default function ({idAlbaran, mostrarIndex}) {
  return apiFetch({endPoint: `Albaran/imprimirAlbaran?idAlbaran=${idAlbaran}&mostrarIndex=${mostrarIndex}`, method: 'GET'})
}